import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { Kitchen } from 'landings';
import { RemoteProps } from './widgets-types';

export const KitchenRemote: React.FC<RemoteProps> = ({ router, store }) => (
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <Kitchen />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
